'use client';

import { useTranslations } from 'next-intl';
import { Link } from './link';

function SitemapHeading({ children }: { children: React.ReactNode }): React.JSX.Element {
  return <h3 className="text-sm/6 font-medium text-foreground/50">{children}</h3>;
}

function SitemapLinks({ children }: { children: React.ReactNode }): React.JSX.Element {
  return <ul className="mt-6 space-y-4 text-sm/6">{children}</ul>;
}

function SitemapLink(props: React.ComponentPropsWithoutRef<typeof Link>): React.JSX.Element {
  return (
    <li>
      <Link {...props} className="font-medium text-foreground data-hover:text-foreground/75" />
    </li>
  );
}

export function FooterSitemap(): React.JSX.Element {
  const t = useTranslations('footer');
  return (
    <>
      <div>
        <SitemapHeading>{t('headings.product')}</SitemapHeading>
        <SitemapLinks>
          <SitemapLink href="/pricing">{t('links.pricing')}</SitemapLink>
          <SitemapLink href="/watch">{t('links.watch')}</SitemapLink>
          <SitemapLink href="/compare">{t('links.compare')}</SitemapLink>
          <SitemapLink href="/app">{t('links.app')}</SitemapLink>
          <SitemapLink href="/explore">{t('links.explore')}</SitemapLink>
          <SitemapLink href="/collection">{t('links.collections')}</SitemapLink>
          <SitemapLink href="/challenge">{t('links.words')}</SitemapLink>
          <SitemapLink href="/cefr">{t('links.cefr')}</SitemapLink>
          <SitemapLink href="/english-exams">{t('links.englishExams')}</SitemapLink>
          <SitemapLink href="/ielts">{t('links.ielts')}</SitemapLink>
          <SitemapLink href="/toefl">{t('links.toefl')}</SitemapLink>
          <SitemapLink href="/pte">{t('links.pte')}</SitemapLink>
          <SitemapLink href="/cambridge">{t('links.cambridge')}</SitemapLink>
          <SitemapLink href="/duolingo-english-test">{t('links.duolingoEnglishTest')}</SitemapLink>
          <SitemapLink href="/for">{t('links.nativeLanguages')}</SitemapLink>
        </SitemapLinks>
      </div>
      <div>
        <SitemapHeading>{t('headings.company')}</SitemapHeading>
        <SitemapLinks>
          <SitemapLink href="/story">{t('links.story')}</SitemapLink>
          <SitemapLink href="/about">{t('links.about')}</SitemapLink>
          <SitemapLink href="/mission">{t('links.mission')}</SitemapLink>
          <SitemapLink href="/vision">{t('links.vision')}</SitemapLink>
          <SitemapLink href="/values">{t('links.values')}</SitemapLink>
          <SitemapLink href="/social-responsibility">{t('links.socialResponsibility')}</SitemapLink>
        </SitemapLinks>
      </div>
      <div>
        <SitemapHeading>{t('headings.resources')}</SitemapHeading>
        <SitemapLinks>
          <SitemapLink href="/changelog">{t('links.changelog')}</SitemapLink>
          <SitemapLink href="/roadmap">{t('links.roadmap')}</SitemapLink>
          <SitemapLink href="/press">{t('links.press')}</SitemapLink>
          <SitemapLink href="/brand">{t('links.brand')}</SitemapLink>
          <SitemapLink href="/logo">{t('links.logo')}</SitemapLink>
          <SitemapLink href="/search">{t('links.search')}</SitemapLink>
        </SitemapLinks>
      </div>
      <div>
        <SitemapHeading>{t('headings.support')}</SitemapHeading>
        <SitemapLinks>
          <SitemapLink href="/contact">{t('links.contact')}</SitemapLink>
          <SitemapLink href="/faq">{t('links.faq')}</SitemapLink>
          <SitemapLink href="/help">{t('links.help')}</SitemapLink>
          <SitemapLink href="/status" target="_blank">
            {t('links.status')}
          </SitemapLink>
        </SitemapLinks>
      </div>
      <div>
        <SitemapHeading>{t('headings.legal')}</SitemapHeading>
        <SitemapLinks>
          <SitemapLink href="/privacy">{t('links.privacy')}</SitemapLink>
          <SitemapLink href="/cookies">{t('links.cookies')}</SitemapLink>
          <SitemapLink href="/terms">{t('links.terms')}</SitemapLink>
          <SitemapLink href="/dmca">{t('links.dmca')}</SitemapLink>
          <SitemapLink href="/accessibility">{t('links.accessibility')}</SitemapLink>
          <SitemapLink href="/delete-account">{t('links.deleteAccount')}</SitemapLink>
        </SitemapLinks>
      </div>
    </>
  );
}
